import {MessageAttemptsHistoryType} from '../../auth/types/Passwordless'
import {safelyGetStorageItem, safelySetStorageItem} from '.'

export const persistMessageSentHistory = (attemptsMap): void => {
  return safelySetStorageItem(
    sessionStorage,
    `MessageSentHistory`,
    JSON.stringify(attemptsMap),
    `MessageSentHistory failed`
  )
}

export const getMessageSentHistory = (): MessageAttemptsHistoryType => {
  return JSON.parse(
    safelyGetStorageItem(
      sessionStorage,
      `MessageSentHistory`,
      `MessageSentHistory failed`
    )
  )
}
